import TPopVue from './poptip.vue'
import TPopJs from './poptip.js'

export default {
  name: 'TPoptip',
  components: {
    't-pop-dynamic': TPopVue,
    't-pop-static': TPopJs
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'static',
      validator (value) {
        return ['static', 'dynamic'].includes(value)
      }
    },
    trigger: {
      type: String,
      default: 'click',
      validator(value) {
        return ['click', 'focus', 'hover'].includes(value)
      }
    },
    placement: {
      type: String,
      default: 'top',
      validator(value) {
        return [
          'top',
          'top-start',
          'top-end',
          'bottom',
          'bottom-start',
          'bottom-end',
          'left',
          'left-start',
          'left-end',
          'right',
          'right-start',
          'right-end'
        ].includes(value)
      }
    },
    title: {
      type: [String, Number]
    },
    content: {
      type: [String, Number]
    },
    width: {
      type: [String, Number]
    },
    confirm: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String
    },
    cancelText: {
      type: String
    },
    tabable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    currentComponent () {
      return 't-pop-' + this.type
    },
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    show() {
      this.$emit('on-popper-show')
    },
    hide() {
      this.$emit('on-popper-hide')
    },
    ok() {
      this.$emit('on-ok')
    },
    cancel() {
      this.$emit('on-cancel')
    }
  },
  template: '<component :is="currentComponent" v-model="model" :trigger="trigger" :placement="placement" :title="title" :content="content" :width="width" :confirm="confirm" :okText="okText" :cancelText="cancelText" :tabable="tabable" @on-popper-show="show" @on-popper-hide="hide" @on-ok="ok" @on-cancel="cancel"><slot></slot><template slot="content"><slot name="content"></slot></template></component>'
}



// WEBPACK FOOTER //
// ./src/components/poptip/slotPopTip.js